import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import TabContent from './TabContent';

function TabMenu() {
  const [current, setCurrent] = useState(0);
  const { t } = useTranslation('guide');
  const menus = t('menu', { returnObjects: true });
  return (
    <Box sx={{ width: '100%', borderTop: '1px solid #ddd', borderBottom: '1px solid #ddd' }}>
      <Tabs value={current} onChange={(e, v) => setCurrent(v)} centered>
        {menus.map((menu, index) => (
          <TabButton key={index} label={menu.name} {...a11yProps(index)} />
        ))}
      </Tabs>
      <TabContent
        name={menus[current].name}
        title={menus[current].title}
        content={menus[current].content}
        imgSrc={menus[current].img}
        button={menus[current].button}
        link={menus[current].buttonLink}
      />
    </Box>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const TabButton = styled(Tab)({
  padding: '20px 60px',
  fontSize: '1.2rem',
  fontFamily: 'Pretendard-Regular',
  color: '#bbb',
});

export default TabMenu;
